/**
 * Renders a template string by replacing placeholders with corresponding values from a variables object.
 *
 * Placeholders should be in the format `{variable_name}` and will be replaced by the value
 * of `variable_name` from the `templateVariables` object.
 *
 * @param {string} templateString - The string containing placeholders to be replaced.
 * @param {Object} templateVariables - An object containing variable values keyed by variable names.
 * @returns {string} - The rendered string with all placeholders replaced by their corresponding values.
 *
 * @example
 * const template = 'Test description with template {test_variable}';
 * const variables = { test_variable: 123 };
 * renderTemplateString(template, variables); // returns 'Test description with template 123'
 */
export function renderTemplateString(templateString, templateVariables) {
  return templateString.replace(/{(.*?)}/g, (_, key) => {
    return key in templateVariables ? templateVariables[key] : `{${key}}`;
  });
}
